// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Documentation_wrapper__iaJtA"};